import { FLASHCARD_BASE_HEIGHT, FLASHCARD_BASE_WIDTH } from '../constants'

export const clamp = (value: number, min: number, max: number) =>
  Math.min(max, Math.max(min, value))
export const clamp01 = (value: number) => clamp(Number.isFinite(value) ? value : 0, 0, 1)
export const clampColor = (value: number) =>
  Math.round(clamp(Number.isFinite(value) ? value : 0, 0, 255))

export const formatPercent = (value: number) => `${(Number.isFinite(value) ? value : 0) * 100}%`

export const scaleWidth = (value: number, size: { width: number; height: number }) =>
  (value / FLASHCARD_BASE_WIDTH) * size.width
export const scaleHeight = (value: number, size: { width: number; height: number }) =>
  (value / FLASHCARD_BASE_HEIGHT) * size.height
